import {connect} from 'react-redux';
import ContractsHistory from './contractsHistory';

export default connect()(ContractsHistory)
